import { makeStyles } from '@material-ui/core/styles'

const drawerWidth = 240

export default makeStyles(theme => ({
  drawer: {
    width: drawerWidth,
    backgroundColor: 'blue',
    flexShrink: 0
  },
  drawerPaper: {
    width: drawerWidth
  },
  toolbar: {
    ...theme.mixins.toolbar,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'black'
  },
  drawerContainer: {
    overflow: 'auto'
  },
  title: {
    color: 'white',
    letterSpacing: '0.2em',
    fontWeight: 700
  },
  primaryText: {
    color: theme.palette.primary.main
  },
  selected: {
    backgroundColor: `${theme.palette.primary.main} !important`
  },
  label: {
    ...theme.typography.caption, textTransform: 'uppercase',
    fontWeight: 700
  },
  labelActive: {
    color: 'rgba(0, 0, 0, 1)'
  },
  labelUnactive: {
    color: 'rgba(0, 0, 0, 0.3)'
  },
  avatar: {
    width: 64,
    height: 64,
    marginTop: '1em',
    backgroundColor: theme.palette.primary.main
  }
}))